<template>
	<!-- we do ternary on v-click-outside because vue otherwise complains -->
	<div
		:id="`room-toolbar-card-${name}`"
		class="tw-absolute tw-flex tw-flex-col tw-bg-white md:tw-bottom-20 tw-bottom-16 tw-cursor-default room-toolbar-card"
		v-click-outside="is_showing ? clickOutside : function() {}"
	>
		<!-- Header -->
		<div id="room-toolbar-card-header">
			<h4 class="tw-text-center title">{{ title }}</h4>
			<hr class="border divider-color"/>
		</div>

        <slot name="input"></slot>
		<!-- Main -->
		<div id="room-toolbar-card-main" class="tw-flex tw-flex-col tw-gap-2 tw-overflow-auto">
			<slot name="main"></slot>
		</div>
	</div>
</template>

<script>
import vClickOutside from 'v-click-outside';
export default {
	name: "ToolbarCard",
	data() {
		return {
			clickOutside: {
				handler: this.close,
				events: ['dblclick', 'click'],
			},
		}
	},
	props: {
		name: {
			required: true,
			type: String,
		},
		title: {
			required: true,
			type: String,
		},
		is_showing: {
			default: false,
			type: Boolean,
		}
	},
	methods: {
		close() {
			if (this.is_showing){
				this.$emit('close');
			}
		},
	},
	directives: {
		clickOutside: vClickOutside.directive,
	},
}
</script>

<style scoped>
.divider-color {
	border-color: #f0f0f0;
}
.title {
	font-size: 1rem;
	font-weight: 600;
	white-space: nowrap;
	color: #37474F;
	margin-bottom: 1.143rem;
}
.room-toolbar-card {
	border-radius: 0.571rem;
	padding: 1.143rem;
	max-height: 45vh;
	min-width: 16.563rem;
}
</style>
